<template>
  <div>
    <v-data-table
    :headers="headers"
    :items="licitacionParticipantes"
    sort-by="aperturaPropuestas.importe"
    >
      <!-- <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="item.createdAt"> </fecha-humano>
      </template> -->
      <template v-slot:[`item.aperturaPropuestas.asistio`]="{ item }">
        <template v-if="item.aperturaPropuestas">
          <v-icon
          v-if="item.aperturaPropuestas.asistio"
          color="green">
            mdi-check-bold
          </v-icon>
          <v-icon
          v-else
          color="red">
            mdi-close-thick
          </v-icon>
        </template>
      </template>
      <template v-slot:[`item.aperturaPropuestas.completa`]="{ item }">
        <template v-if="item.aperturaPropuestas">
          <v-icon
          v-if="item.aperturaPropuestas.completa"
          color="green">
            mdi-check-bold
          </v-icon>
          <v-icon
          v-else
          color="red">
            mdi-close-thick
          </v-icon>
        </template>
      </template>
      <template v-slot:[`item.aperturaPropuestas.aceptadaRevision`]="{ item }">
        <template v-if="item.aperturaPropuestas">
          <v-icon
          v-if="item.aperturaPropuestas.aceptadaRevision"
          color="green">
            mdi-check-bold
          </v-icon>
          <v-icon
          v-else
          color="red">
            mdi-close-thick
          </v-icon>
        </template>
      </template>
      <template v-slot:[`item.aperturaPropuestas.pasoRevision`]="{ item }">
        <template v-if="item.aperturaPropuestas">
          <v-icon
          v-if="item.aperturaPropuestas.pasoRevision"
          color="green">
            mdi-check-bold
          </v-icon>
          <v-icon
          v-else
          color="red">
            mdi-close-thick
          </v-icon>
        </template>
      </template>
      <template v-slot:[`item.aperturaPropuestas.importe`]="{ item }">
        <template v-if="item.aperturaPropuestas">
          {{ item.aperturaPropuestas.importe | currency}}
        </template>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <template v-if="!item.aperturaPropuestas">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="mixValidaScopesActions(2)"
                icon
                v-bind="attrs"
                v-on="on"
                @click="nuevaPropuestaParticipante(item)"
              >
                <v-icon>mdi-folder-plus</v-icon>
              </v-btn>
            </template>
            <span>Propuesta del Participante</span>
          </v-tooltip>
        </template>
        <template v-else>
          <v-tooltip
            v-if="mixValidaScopesActions(2)"
            top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="editarPropuestaParticipante(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Propuesta del Participante</span>
          </v-tooltip>
        </template>
      </template>
    </v-data-table>
  </div>
</template>

<script>
// import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoAperturaPropuestasLicitacionDesktop',
  props: {
    licitacionParticipantes: {
      type: Array,
      required: true,
    },
  },
  components: {
    // FechaHumano,
  },
  data() {
    return {
      headers: [
        // {
        //   text: 'RFC',
        //   align: 'start',
        //   width: '200',
        //   sortable: false,
        //   value: 'contratista.rfc',
        // },
        { text: 'Razón Social', value: 'contratista.nombreRazonSocial', sortable: false },
        // { text: 'Correo Electrónico', value: 'contratista.correoElectronico' },
        // { text: 'Fecha de Registro', value: 'createdAt' },
        {
          text: '¿Asistió?', width: '100', align: 'center', value: 'aperturaPropuestas.asistio', sortable: false,
        },
        {
          text: '¿Completa?', width: '100', align: 'center', value: 'aperturaPropuestas.completa', sortable: false,
        },
        {
          text: '¿Aceptada Revisión?', width: '100', align: 'center', value: 'aperturaPropuestas.aceptadaRevision', sortable: false,
        },
        {
          text: '¿Pasó Revisión?', width: '100', align: 'center', value: 'aperturaPropuestas.pasoRevision', sortable: false,
        },
        {
          text: 'Importe', width: '100', align: 'end', value: 'aperturaPropuestas.importe', sortable: false,
        },

        {
          text: '',
          value: 'acciones',
          align: 'end',
          sortable: false,
        },
      ],
    };
  },
  // apollo: {
  //   licitacionParticipantes: {
  //     query: LICITACION_PARTICIPANTES,
  //     variables() {
  //       return {
  //         idLicitacion: this.$route.params.idLicitacion,
  //       };
  //     },
  //   },
  // },
  methods: {
    nuevaPropuestaParticipante(participanteLicitacion) {
      eventBus.$emit('agregar-propuesta-participante', participanteLicitacion);
    },
    editarPropuestaParticipante(participanteLicitacion) {
      eventBus.$emit('editar-propuesta-participante', participanteLicitacion);
    },
  },
};
</script>

<style lang="scss">
</style>
